import { useEffect, useState } from 'react';

const HIGH_ZOOM_DEVICE_PIXEL_RATIO = 2.5;

const getIsDesktopHighZoom = () => {
  if (typeof window === 'undefined') return false;

  const isMobileDevice =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  const hasTouchPoints = (navigator?.maxTouchPoints || 0) > 0;

  return (
    !isMobileDevice &&
    !hasTouchPoints &&
    window.matchMedia?.('(hover: hover) and (pointer: fine)')?.matches &&
    window.devicePixelRatio >= HIGH_ZOOM_DEVICE_PIXEL_RATIO
  );
};

export const useIsDesktopHighZoom = () => {
  const [isDesktopHighZoom, setIsDesktopHighZoom] = useState(
    getIsDesktopHighZoom,
  );

  useEffect(() => {
    const handleResize = () => setIsDesktopHighZoom(getIsDesktopHighZoom());

    window.addEventListener('resize', handleResize);
    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, []);

  return isDesktopHighZoom;
};
